import React from "react";
import { Plus } from "lucide-react";

export const BLANK_BUNDLE = {
  slug: "",
  name: "",
  pairs: 1,
  price: 18.0,
  saving: 0.0,
  description: "",
  tag: "",
  featured: false,
  is_active: true,
  sort_order: 0,
};

const FIELDS = [
  ["slug", "Slug"],
  ["name", "Name"],
  ["pairs", "Pairs"],
  ["price", "Price (£)"],
  ["saving", "Saving (£)"],
  ["tag", "Tag (e.g. Most popular)"],
];

const BundleCreateRow = ({ draft, setDraft, onCreate }) => (
  <div
    className="bg-white border border-ink p-4 mb-4 grid grid-cols-2 md:grid-cols-4 gap-3 items-end"
    data-testid="bundle-create-row"
  >
    {FIELDS.map(([k, label]) => (
      <label key={k} className="block">
        <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
          {label}
        </span>
        <input
          value={draft[k]}
          onChange={(e) => setDraft({ ...draft, [k]: e.target.value })}
          type={k === "price" || k === "pairs" || k === "saving" ? "number" : "text"}
          step={k === "price" || k === "saving" ? "0.01" : "1"}
          className="w-full border border-line px-3 py-2 bg-chalk"
        />
      </label>
    ))}
    <label className="block col-span-2 md:col-span-4">
      <span className="text-[11px] tracking-[0.16em] uppercase font-bold block mb-1">
        Description
      </span>
      <input
        value={draft.description}
        onChange={(e) => setDraft({ ...draft, description: e.target.value })}
        className="w-full border border-line px-3 py-2 bg-chalk"
      />
    </label>
    <button
      type="button"
      onClick={onCreate}
      className="btn-primary"
      data-testid="bundle-create-submit"
    >
      <Plus size={12} className="mr-1" /> Create bundle
    </button>
  </div>
);

export default BundleCreateRow;
